import React from 'react';
import { Pressable, View } from 'react-native';
import { Link } from 'expo-router';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import { useInteractive, useLanding } from '@/components/Landing/LandingKit';

export function DocsTopicLink({ href, title, description, onPress, active = false, compact = false, minHeight = 40 }) {
  const { c } = useLanding();
  const { hovered, handlers } = useInteractive();
  return (
    <Link href={href} asChild>
      <Pressable {...handlers} onPress={onPress} accessibilityRole="link" aria-current={active ? 'page' : undefined} style={{ flexDirection: 'row', alignItems: description ? 'flex-start' : 'center', gap: 14, minHeight, paddingVertical: compact ? 8 : 17, paddingHorizontal: compact ? 12 : 0, borderRadius: compact ? 4 : 0, backgroundColor: compact && (active || hovered) ? c.accentSoft : 'transparent', borderBottomWidth: compact ? 0 : 1, borderBottomColor: c.rule }}>
        <View style={{ flex: 1, minWidth: 0 }}>
          <Text weight={active || !compact ? 'medium' : 'regular'} style={{ color: active || hovered ? c.accent : c.ink, fontSize: compact ? 14 : 17, lineHeight: compact ? 22 : 25 }}>{title}</Text>
          {description ? <Text style={{ color: c.inkSoft, fontSize: 14, lineHeight: 23, marginTop: 6 }}>{description}</Text> : null}
        </View>
        {!compact && <Icon name="arrow-up-right" size={11} color={c.muted} style={description ? { marginTop: 7 } : undefined} />}
      </Pressable>
    </Link>
  );
}
